import { render, staticRenderFns } from "./importDialog.vue?vue&type=template&id=07c4befe&scoped=true"
import script from "./importDialog.vue?vue&type=script&lang=js"
export * from "./importDialog.vue?vue&type=script&lang=js"
import style0 from "./importDialog.vue?vue&type=style&index=0&id=07c4befe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c4befe",
  null
  
)

export default component.exports